<template>
  <div :class="'md-layout'">
    <div :class="'md-layout-item md-size-100'">
      <md-card>
        <md-card-header :class="'md-card-header-icon md-card-header-danger'">
          <div :class="'card-icon'">
            <md-icon>assignment</md-icon>
          </div>
          <h4 :class="'title'">
            List
            <md-button :class="'md-danger pull-right'" @click.prevent="isTryingToCreate = true"
              v-if="cannotView() && emails.length > 0">
              New
            </md-button>
          </h4>
        </md-card-header>
        <md-card-content>

          <!--Filters-->
          <div :class="'md-layout'">
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33'">
              <md-field md-clearable>
                <label>Status</label>
                <md-select id="filter.reviewer_status" v-model="filter.reviewer_status" @input="getEmails">
                  <md-option :value="code" :key="code" v-for="(type, code) in emailStatusMap">
                    {{ type }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33'">
              <md-field>
                <label>Email</label>
                <md-input placeholder="Email" v-model="filter.email" @input="getEmails" />
              </md-field>
            </div>
          </div>

          <!--Table-->
          <md-table v-model="emails" table-header-color="orange">
            <md-empty-state md-icon="list" md-label="Emails" :md-description=" 'No emails found' +
              (this.filtersQuery ? ' with the searched terms' : '')" v-if="!isFetching">
              <md-button v-if="cannotView()" :class="'md-primary md-raised'" @click.prevent="isTryingToCreate = true">
              New
            </md-button>
            </md-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item: email }">
              <md-table-cell md-label="Status">{{ email.reviewer_status | emailStatus }}</md-table-cell>
              <md-table-cell md-label="Email">{{ email.text }}</md-table-cell>
              <md-table-cell v-if="cannotView()" md-label="Actions" md-numeric>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="tryToEdit(email)"
                  title="Edit email">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="tryToDelete(email)"
                  title="Delete email">
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div :class="'md-flex text-center'" v-if="emails.length > 0">
            <Pagination :total="pagination.totalItems" :value="pagination.currentPage" :perPage="pagination.perPage"
              @input="changePage" />
          </div>
          <div :class="'md-flex text-center'" v-if="isFetching">
            <md-progress-spinner :class="'md-accent'" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <!--Delete-->
    <md-dialog :md-active.sync="isTryingToDelete">
      <md-dialog-title>Delete email</md-dialog-title>
      <md-dialog-content>
        Are you sure you want to delete <b>{{ deletableEmail.text }}</b>?
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="isDeletingEmail" @click.prevent="dismissDeleteModal">Cancel</md-button>
        <md-button :class="'md-primary'" :disabled="isDeletingEmail" @click.prevent="deleteEmail(deletableEmail)">
          {{ !isDeletingEmail ? "Delete" : "Deleting..." }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!--Create-->
    <md-dialog :md-active.sync="isTryingToCreate">
      <md-dialog-title>Create email</md-dialog-title>
      <md-dialog-content>
        <div :class="'md-layout'">
          <div :class="'md-layout-item md-size-100'">
            <md-field>
              <label for="user-type">Status</label>
              <md-select v-model="newEmail.reviewer_status" id="new.reviewer_status">
                <md-option :value="code" :key="code" v-for="(type, code) in emailStatusMap">
                  {{ type }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div :class="'md-layout-item md-size-100'">
            <md-field :class="$v.newEmail.text.$error ? 'md-error' : ''">
              <label for="text">Email text</label>
              <md-input id="text" @blur="$v.newEmail.text.$touch()" v-model="newEmail.text" maxlength="254"
                :disabled="isCreatingEmail" />
            </md-field>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="isCreatingEmail" @click.prevent="dismissCreatingModal">Cancel</md-button>
        <md-button :class="'md-primary'" :disabled="isCreatingEmail || !isValidForm" @click.prevent="createEmail">
          {{ !isCreatingEmail ? "Create" : "Creating..." }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <!--Edit-->
    <md-dialog :md-active.sync="isTryingToEdit">
      <md-dialog-title>Edit email</md-dialog-title>
      <md-dialog-content>
        <div :class="'md-layout'">
          <div :class="'md-layout-item md-size-100'">
            <md-field>
              <label for="user-type">Status</label>
              <md-select v-model="editableEmail.reviewer_status" id="section">
                <md-option :value="code" :key="code" v-for="(type, code) in emailStatusMapEdit">
                  {{ type }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div :class="'md-layout-item md-size-100'">
            <md-field :class="$v.editableEmail.text.$invalid ? 'md-error' : ''">
              <label for="text">Email</label>
              <md-input id="text" v-model="editableEmail.text" :disabled="isEditingEmail" />
            </md-field>
            <small :style="'color: #f44336'" v-if="!$v.editableEmail.text.required">The email is required</small>
            <small :style="'color: #f44336'" v-else-if="!$v.editableEmail.text.maxLength">Invalid email length</small>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button :disabled="isEditingEmail" @click.prevent="dismissEditModal">Cancel</md-button>
        <md-button :class="'md-primary'" :disabled="$v.editableEmail.$invalid || isEditingEmail"
          @click.prevent="editEmail">
          {{ !isEditingEmail ? "Update" : "Updating..." }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { maxLength, required } from "vuelidate/lib/validators";
import { date, emailStatus } from "@/filters";
import { emailStatusMap } from "@/filters/emailStatus";
import { Pagination } from "@/components";
import { camelToSnake } from "@/methods/api/requests";
import * as utils from "@/utils";
import * as filters from "@/filters";

export default {
  created() {
    this.getEmails();
  },

  data() {    
    const itensRemoveStausEmail = [3, 5, 7] //cod dos itens para remoção do objeto emailStatusMap
    return {
      emails: [],
      isFetching: false,
      isTryingToDelete: false,
      deletableEmail: {},
      isDeletingEmail: false,
      isValidForm: false,
      isTryingToCreate: false,
      isCreatingEmail: false,
      newEmail: {
        text: "",
        reviewer_status: 2,
      },
      isTryingToEdit: false,
      editableEmail: { reviewer_status: 1 },
      isEditingEmail: false,
      edit: {
        reviewer_status: 2,
      },
      options: [],
      newOption: "",
      selectedOptions: [],
      filter: {
        email: "",
        reviewer_status: "",
        section: "",
      },
      pagination: {
        totalItems: "",
        currentPage: "",
        perPage: "",
      },
      errorResponses: {
        400: "The users spreadsheet is invalid",
        422: "There is an error with your file",
      },
      emailStatusMap,
      emailStatusMapEdit: Object.fromEntries(Object.entries(emailStatusMap).filter(([key]) => 
        !itensRemoveStausEmail.includes(Number(key))) //Remoção dos itens do objeto emailStatusMap
      ),
    };
  },

  components: {
    Pagination,
  },

  computed: {
    filtersQuery() {
      return filters.getFiltersQuery(this.filter);
    },

    paginationQuery() {
      return utils.getPaginationQuery(this.pagination.currentPage);
    },

    sections() {
      const secs = [];
      const obj = this.isTryingToCreate ? emailStatus(this.newEmail.reviewer_status) 
        : emailStatus(this.editableEmail.reviewer_status);

      Object.entries(obj).forEach(([key, value]) =>
        secs.push({ value: key, label: value })
      );

      return secs;
    },

    sectionsForFilter() {
      const secs = [];
      const obj = emailStatus(this.filter.reviewer_status);

      Object.entries(obj).forEach(([key, value]) =>
        secs.push({ value: key, label: value })
      );

      return secs;
    },
  },

  filters: {
    date,
    emailStatus,
  },

  methods: {
    addOption() {
      if (this.newOption !== "") {
        this.options.push({ text: this.newOption });
        this.newOption = "";
      } else {
        this.$toast.show(`Please fill in the option field`, "");
      }
    },
    
    cannotView() {
      return utils.getCannotView(this.$store.state.currentProfile)
    },

    changePage(toPage) {
      if (toPage === this.pagination.currentPage)
        return;

      this.pagination.currentPage = toPage;
      this.getEmails();
    },

    createEmail() {
      if (this.isCreatingEmail)
        return;

      this.newEmail.options = this.selectedOptions;
      this.$api.request
        .post(`messages`, this.newEmail)
        .then(() => {
          this.dismissCreatingModal();
          this.isCreatingEmail = false;
          this.getEmails();
          this.$toast.show(
            `<b>Email</b> was created successfully`,
            "The email has been created successfully"
          );
        })
        .catch(({ response }) => {
          if (response.status === 409) {
            this.$toast.show(`<b>Error</b>`, 'Status already registered');
          } else {
            this.$toast.show(`<b>Error</b>`, response.data.message);
          }
        })
        .finally(() => {
          this.isCreatingEmail = false;
        });
    },

    deleteEmail() {
      if (this.isDeletingEmail)
        return;

      this.isDeletingUser = true;
      this.$api.request
        .delete(`messages/${this.deletableEmail.id}`)
        .then(() => {
          this.isDeletingEmail = false;
          this.$toast.show(
            `<b>Email</b> was deleted successfully`,
            "The email has been deleted successfully"
          );
          this.getEmails();
        })
        .catch((error) => {
          this.$toast.warning(error.response.data.message, "");
        })
        .finally(() => {
          this.isDeletingEmail = false;
          this.dismissDeleteModal();
        });
    },

    dismissCreatingModal() {
      if (this.isCreatingEmail)
        return;      

      this.isTryingToCreate = false;
      this.selectedOptions = [];
      this.newEmail = {
        text: "",
        reviewer_status: 2,
      };
      this.$v.newEmail.$reset();
    },

    dismissDeleteModal() {
      if (this.isDeletingEmail)
        return;      

      this.isTryingToDelete = false;
    },

    dismissEditModal() {
      if (this.isEditingEmail)
        return;

      this.isTryingToEdit = false;
      this.selectedOptions = [];
    },

    editEmail() {
      if (this.isEditingEmail)
        return;

      this.isEditingEmail = true;
      this.$api.request
        .put(`messages/${this.editableEmail.id}`, this.editableEmail)
        .then(() => {
          this.isEditingEmail = false;
          this.getEmails();
          this.$toast.show(
            `<b>Email</b> was updated successfully`,
            "The email has been updated successfully"
          );
        })
        .catch((error) => {
          this.$toast.warning(error.response.data.message, "");
        })
        .finally(() => {
          this.isEditingEmail = false;
          this.dismissEditModal();
        });
    },

    getEmails() {
      this.isFetching = true;
      this.$api
        .request(`messages?${this.filtersQuery}${this.paginationQuery}`)
        .then((response) => {
          this.emails = camelToSnake(response.data.data);

          this.pagination.totalItems = response.data.meta.total;
          this.pagination.currentPage = response.data.meta.currentPage;
          this.pagination.perPage = response.data.meta.perPage;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    isValidNumber(value, field) {
      if (isNaN(value))
        this[field].email_order = "";
      else if (value < 0)
        this[field].email_order = "";      
    },

    tryToDelete(email) {
      this.isTryingToDelete = true;
      this.deletableEmail = email;
    },

    tryToEdit(email) {
      this.isTryingToEdit = true;
      this.editableEmail = Object.assign({}, email);
      this.edit.reviewer_status = email.reviewer_status;
      this.edit.first = true;
    },    

    validateNewEmail() {
      this.isValidForm = !this.$v.newEmail.$invalid;
      if (this.newEmail.type === 1 || this.newEmail.type === 7) {
        if (this.selectedOptions.length === 0)
          this.isValidForm = false;       
      }
    },
  },

  validations: {
    newEmail: {
      text: {
        required,
        maxLength: maxLength(254),
      },
      reviewer_status: {
        required,
      },
    },
    editableEmail: {
      text: {
        required,
        maxLength: maxLength(254),
      },
      reviewer_status: {
        required,
      },
    },
  },

  watch: {
    "$v.newEmail.$invalid": function () {
      this.validateNewEmail();
    },

    selectedOptions: function () {
      if (this.isTryingToCreate)
        this.validateNewEmail();
    },
  },
};
</script>